import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { useState } from 'react';

import CollapseIcon from '@/assets/svg/bx-collapse.svg?react';
import ExpandIcon from '@/assets/svg/bx-expand.svg?react';
import LinkExternalIcon from '@/assets/svg/bx-link-external.svg?react';
import { Button, LinkButton } from '@/components/buttons';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/Tooltip';

import { type DashboardLink } from './types';

type Props = {
  link?: DashboardLink;
  isExpanded?: boolean;
  canExpand?: boolean;
  onExpandToggle: (isExpanded: boolean) => void;
};

const DashboardWidgetActions = ({
  link,
  isExpanded = false,
  canExpand = true,
  onExpandToggle,
}: Props) => {
  const [showExpandToggleTooltip, setShowExpandToggleTooltip] = useState(false);

  return (
    <div>
      {link?.url && (
        <Tooltip>
          <TooltipTrigger
            render={
              <LinkButton variant="ghost" aria-label={t`Visit page`} size="icon" to={link.url}>
                <LinkExternalIcon />
              </LinkButton>
            }
          />
          <TooltipContent side="top">
            <Trans>Take Me to {link.title}</Trans>
          </TooltipContent>
        </Tooltip>
      )}
      {canExpand && (
        <Tooltip open={showExpandToggleTooltip} onOpenChange={setShowExpandToggleTooltip}>
          <TooltipTrigger
            render={
              isExpanded ? (
                <Button
                  variant="ghost"
                  aria-label={t`Collapse View`}
                  size="icon"
                  onClick={() => {
                    setShowExpandToggleTooltip(false);
                    onExpandToggle(false);
                  }}
                >
                  <CollapseIcon />
                </Button>
              ) : (
                <Button
                  variant="ghost"
                  aria-label={t`Expand View`}
                  size="icon"
                  onClick={() => {
                    setShowExpandToggleTooltip(false);
                    onExpandToggle(true);
                  }}
                >
                  <ExpandIcon />
                </Button>
              )
            }
          />
          <TooltipContent side="top">
            {isExpanded ? <Trans>Collapse View</Trans> : <Trans>Expand View</Trans>}
          </TooltipContent>
        </Tooltip>
      )}
    </div>
  );
};

export default DashboardWidgetActions;
